<template>
  <strong>
    <ArticleContentRenderer
      v-if="children"
      :content="children"
      :preloaded-data="preloadedData"
    />
  </strong>
</template>

<script lang="ts" setup>
  import ArticleContentRenderer from './ArticleContentRenderer.vue';
  import type { PreloadedData } from './lib/articleComponents';
  import type { ArticleContent } from './models/ArticleContent';

  export interface Props {
    children?: ArticleContent;
    preloadedData: PreloadedData;
  }

  defineProps<Props>();
</script>
